module.exports = __webpack_public_path__ + "static/media/bg1.17d118fe.jpg";